import React from 'react'
// libs
import { QRCodeCanvas } from 'qrcode.react'
import { Checkbox, FormControlLabel } from '@mui/material'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import BackupCodesDisplay from './BackupCodesDisplay'
// constants
import { QR_CODE_SIZE } from '../constants'
// views
import { QRCodeContainer, StepTitle } from '../views'

interface Props {
  otpauthUri: string
  backupCodes: string[]
  onNext: () => void
}

const SetupStep: React.FC<Props> = ({ otpauthUri, backupCodes, onNext }) => {
  const [acknowledged, setAcknowledged] = React.useState(false)

  const onBackupConfirm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAcknowledged(e.target.checked)
  }

  return (
    <div>
      <StepTitle>Step 1: Scan QR Code</StepTitle>
      <p>Scan this QR code with your authenticator app (Google Authenticator, Microsoft Authenticator, etc.)</p>

      <QRCodeContainer>
        <QRCodeCanvas value={otpauthUri} size={QR_CODE_SIZE} />
      </QRCodeContainer>

      <StepTitle>Step 2: Save Your Backup Codes</StepTitle>

      <p>
        These backup codes can be used if you lose access to your authenticator app. Each code can only be used once.
        Store them in a secure location.
      </p>

      <BackupCodesDisplay codes={backupCodes} />

      <FormControlLabel
        control={<Checkbox checked={acknowledged} onChange={onBackupConfirm} />}
        label='I have saved my backup codes in a secure location'
        sx={{ marginTop: '20px', marginBottom: '20px' }}
      />

      <br />

      <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={onNext} disabled={!acknowledged}>
        Next: Verify Setup
      </Button>
    </div>
  )
}

export default SetupStep
